import { RefreshCw } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { L } from "@/i18n";

export const DashboardHeader = ({ updatedAt, fetching, onRefresh }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-amber-500">{L("Overview", "Visão geral")}</p>
      <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-slate-50 tracking-tight" data-testid="dashboard-title">
        Dashboard
      </h1>
    </div>
    <div className="flex items-center gap-4">
      <span className="flex items-center gap-2 text-xs text-slate-400" data-testid="dashboard-live-indicator">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
        </span>
        {L("Live", "Em direto")} · {updatedAt ? fmtDate(updatedAt, "HH:mm:ss") : "—"}
      </span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={fetching}
        data-testid="dashboard-refresh-button"
        className="flex items-center gap-2 rounded-md border border-slate-700 px-3 py-2 text-xs text-slate-300 hover:border-amber-500/50 hover:text-amber-400 transition-colors disabled:opacity-60"
      >
        <RefreshCw className={`h-3.5 w-3.5 ${fetching ? "animate-spin" : ""}`} />
        {L("Refresh", "Atualizar")}
      </button>
    </div>
  </div>
);
